import type { AxiosResponse } from "axios";

import { deleteData, getData, postData } from "@/apis/apiInstance";

import type {
  AddClientCategoryPayloadType,
  AddUsersDepartmentPayloadType,
  CreateActivityCodeDataPayloadType,
  CreateBranchDataPayloadType,
  CreateClientGroupDataPayloadType,
  CreateCurrencyDataPayloadType,
  CreateEmailersDataPayloadType,
  CreateHolidayCalenderPayloadType,
  DeleteHolidayCalenderPayloadType,
  GetAllMasterDataActivityCodePayloadType,
  GetAllMasterDataBranchPayloadType,
  GetAllMasterDataCurrencyPayloadType,
  GetCityListDataPayloadType,
  GetClientCategoryPayloadType,
  GetClientGroupDataPayloadType,
  GetCountryListDataPayloadType,
  GetCurrencyExchangeDetailsPayloadType,
  GetUsersDepartmentPayloadType,
  GetEmailerDataPayloadType,
  GetHolidayCalenderPayloadType,
  GetStateListDataPayloadType,
  UniqueClientGroupNamePayloadType,
  UpdateActivityCodeDataPayloadType,
  UpdateBranchDataPayloadType,
  UpdateClientCategoryPayloadType,
  UpdateClientGroupDataPayloadType,
  UpdateCurrencyDataPayloadType,
  UpdateEmailerDataPayloadType,
  UpdateHolidayCalenderPayloadType,
  UpdateUsersDepartmentPayloadType,
  DeleteUsersDepartmentPayloadType,
  DeleteTdsPayloadType,
  TdsInfoType,
  TdsSinglePayloadType,
  GetTdsMasterPayloadType,
  AddScopeOfWorkPayloadType,
  UpdateScopeOfWorkPayloadType,
  DeleteScopeOfWorkPayloadType,
  AddSkillsPayloadType,
  UpdateSkillsPayloadType,
  DeleteSkillsPayloadType,
  AddQualificationPayloadType,
  UpdateQualificationPayloadType,
  DeleteQualificationPayloadType,
  GetMasterDataListPayloadType,
  DeleteTcsPayloadType,
  TcsSinglePayloadType,
  TcsInfoType,
  UniqueCheckCodePayloadType,
  AddPdfTemplatePayloadType,
  UpdatePdfTemplatePayloadType,
  DeletePdfTemplatePayloadType,
  UniqueMasterDataPayloadType,
  GetJobTitlePayloadType,
  AddJobTitlePayloadType,
  UpdateJobTitlePayloadType,
  DeleteJobTitlePayloadType,
  AddTicketCategoryPayloadType,
  AddTicketSubCategoryPayloadType,
  GetTicketCategoryDetailsPayloadType,
  GetTicketCategoryListPayloadType,
  GetTicketSubCategoryListPayloadType,
  UpdateTicketCategoryPayloadType,
  UpdateTicketCategoryStatusPayloadType,
  UpdateTicketSubCategoryPayloadType,
  UpdateTicketSubCategoryStatusPayloadType,
  AddKraPayloadType,
  UpdateKraPayloadType,
  ListKraPayloadType,
  UpdateKraStatusPayloadType,
  DeleteKraPayloadType,
  AddKpiPayloadType,
  GetKpiListPayloadType,
  GetSingleKpiDetailsPayloadType,
  UpdateKpiPayloadType,
  NatureOfTransactionPayloadType,
} from "@/commonTypes/masterDataTypes";

import { getCSRFToken } from "@/utils/commonFunctions";

export async function createMasterDataBranchApi(
  data: CreateBranchDataPayloadType
): Promise<AxiosResponse> {
  const { token, branch_name, branch_status } = data;
  return await postData(
    `/master-module/branch/add`,
    { branch_name, branch_status },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getMasterDataBranchApi(
  data: GetAllMasterDataBranchPayloadType
): Promise<AxiosResponse> {
  const { token, search_term, branch_status } = data;

  const finalParams = {
    branch_status,
    //
    ...(search_term && search_term.length > 0 && { search_term: search_term }),
  };
  return await getData(`master-module/branch/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function updateMasterDataBranchApi(
  data: UpdateBranchDataPayloadType
): Promise<AxiosResponse> {
  const { token, _id, branch_name, branch_status } = data;
  return await postData(
    `master-module/branch/update`,
    { _id, branch_name, branch_status },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function checkUniqueBranchNameApi(
  data: UniqueMasterDataPayloadType
): Promise<AxiosResponse> {
  const { token, operation, branchName, name, data_id, unique_check, type } =
    data;

  const finalParams = {
    operation,
    name: branchName || name,
    unique_check,
    data_id,
    type: type,
  };
  return await getData(`master-module/master-data/unique/check`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function checkUniquePdfTemplateApi(
  data: UniqueMasterDataPayloadType
): Promise<AxiosResponse> {
  const { token, operation, branchName, name, data_id, unique_check } = data;

  const finalParams = {
    operation,
    template_name: branchName || name,
    id: data_id,
  };
  return await getData(`invoice-generation/pdf-template/unique/check`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function createMasterDataActivityCodeApi(
  data: CreateActivityCodeDataPayloadType
): Promise<AxiosResponse> {
  const { token, activity_code, description, activity_code_type } = data;
  return await postData(
    `/master-module/activity-code/add`,
    { activity_code, description, activity_code_type },

    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getMasterDataActivityCodeApi(
  data: GetAllMasterDataActivityCodePayloadType
): Promise<AxiosResponse> {
  const { token, search_term, activity_code_type } = data;
  const finalParams = {
    activity_code_type,
    ...(search_term && search_term.length > 0 && { search_term: search_term }),
  };
  return await getData(`master-module/activity-code/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
//
export async function updateMasterDataActivityCodeApi(
  data: UpdateActivityCodeDataPayloadType
): Promise<AxiosResponse> {
  const { token, _id, activity_code, description, activity_code_type } = data;
  return await postData(
    `/master-module/activity-code/update`,
    { _id, activity_code, description, activity_code_type },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getAllMasterDataBranchListApi(
  data: GetAllMasterDataBranchPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, search_term, limit, offset, branch_status } =
    data;

  const finalParams = {
    client_code,
    limit,
    offset,
    branch_status,
    //
    ...(search_term && search_term.length > 0 && { search_term: search_term }),
  };
  return await getData(`master-module/branch/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllMasterDataActivityCodeListApi(
  data: GetAllMasterDataActivityCodePayloadType
): Promise<AxiosResponse> {
  const { token, client_code, search_term, limit, offset, activity_code_type } =
    data;

  const finalParams = {
    client_code,
    limit,
    offset,
    activity_code_type,
    ...(search_term && search_term.length > 0 && { search_term: search_term }),
  };
  return await getData(`master-module/activity-code/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// currency
export async function createMasterDataCurrencyApi(
  data: CreateCurrencyDataPayloadType
): Promise<AxiosResponse> {
  const { token, currency_name, currency_sign, currency_short_form } = data;
  return await postData(
    `/master-module/currency/add`,
    { currency_name, currency_sign, currency_short_form },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getMasterDataCurrencyApi(
  token: string | null
): Promise<AxiosResponse> {
  return await getData(`/master-module/currency/list`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function updateMasterDataCurrencyApi(
  data: UpdateCurrencyDataPayloadType
): Promise<AxiosResponse> {
  const { token, _id, currency_name, currency_sign, currency_short_form } =
    data;
  return await postData(
    `/master-module/currency/update`,
    { _id, currency_name, currency_sign, currency_short_form },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getAllMasterDataCurrencyListApi(
  data: GetAllMasterDataCurrencyPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, search_term, limit, offset, currency_name } =
    data;

  const finalParams = {
    client_code,
    limit,
    offset,
    currency_name,
    ...(search_term && search_term.length > 0 && { search_term: search_term }),
  };
  return await getData(`/master-module/currency/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

//Client Gropup

export async function createMasterDataClientGroupApi(
  data: CreateClientGroupDataPayloadType
): Promise<AxiosResponse> {
  const { token, clientGroupName } = data;
  const finalData = {
    client_group_name: clientGroupName ? clientGroupName.trim() : "",
  };
  return await postData(`master-module/client-group/add`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
export async function getMasterDataClientGroupApi(
  data: GetClientGroupDataPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, searchValue } = data;
  const finalParams = {
    limit,
    offset,
    search_term: searchValue,
  };
  return await getData(`master-module/client-group/list?`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function updateMasterDataClientGroupApi(
  data: UpdateClientGroupDataPayloadType
): Promise<AxiosResponse> {
  const { token, id, clientGroupName } = data;
  const finalData = {
    _id: id,
    client_group_name: clientGroupName ? clientGroupName.trim() : "",
  };
  return await postData(`master-module/client-group/update`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
export async function checkUniqueClientGroupNameApi(
  data: UniqueClientGroupNamePayloadType
): Promise<AxiosResponse> {
  const { token, operation, uniqueCheck, name, dataId } = data;

  const finalParams = {
    operation,
    name,
    unique_check: uniqueCheck,
    data_id: dataId,
  };
  return await getData(`master-module/master-data/unique/check`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
// emailers
export async function getMasterDataEmailersApi(
  data: GetEmailerDataPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, searchValue, status } = data;
  const finalParams = {
    limit,
    offset,
    srch_term: searchValue,
    status,
  };
  return await getData(`/finac-crm/email-master/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function createMasterDataEmailersApi(
  data: CreateEmailersDataPayloadType
): Promise<AxiosResponse> {
  const { token, email_name, description, subject } = data;
  return await postData(
    `/finac-crm/email-master/add`,
    { email_name, description, subject },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateMasterDataEmailersApi(
  data: UpdateEmailerDataPayloadType
): Promise<AxiosResponse> {
  const { token, _id, email_name, description, status, subject } = data;
  return await postData(
    `/finac-crm/email-master/update?_id=${_id}`,
    { email_name, description, status, subject },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

// holiday calender api

export async function getMasterDataHolidayCalenderApi(
  data: GetHolidayCalenderPayloadType
): Promise<AxiosResponse> {
  const {
    token,
    limit,
    offset,
    searchValue,
    country,
    start_date,
    end_date,
    sort_by,
    sort_by_value,
    user_id_filter,
    branch_id_filter,
  } = data;
  const finalParams = {
    limit,
    offset,
    end_date,
    start_date,
    sort_by,
    sort_by_value,
    // search_term:searchValue,
    ...(searchValue && searchValue.length > 0 && { search_term: searchValue }),
    user_id_filter,
    branch_id_filter,
    country,
  };
  return await getData(`master-module/calender/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function createMasterDataHolidayCalenderApi(
  data: CreateHolidayCalenderPayloadType
): Promise<AxiosResponse> {
  const { token, date, description, country, branch, subDescription } = data;

  return await postData(
    `/master-module/calender/add`,
    {
      date,
      description,
      country,
      branch_ids: branch,
      sub_description: subDescription,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateMasterDataHolidayCalenderApi(
  data: UpdateHolidayCalenderPayloadType
): Promise<AxiosResponse> {
  const { token, _id, date, description, country, branch, subDescription } =
    data;
  return await postData(
    `/master-module/calender/update`,
    {
      _id,
      date,
      description,
      country,
      branch_ids: branch,
      sub_description: subDescription,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function deleteHolidayCalenderApi(
  data: DeleteHolidayCalenderPayloadType
): Promise<AxiosResponse> {
  const { token, id } = data;

  return await deleteData(`/master-module/calender/delete`, {
    headers: {
      "user-token": token,
      "Content-Type": "application/json",
      "x-csrf-token": getCSRFToken(),
    },
    params: {
      id: id,
    },
  });
}

//  country api

export async function getAllCountryApi(
  data: GetCountryListDataPayloadType
): Promise<AxiosResponse> {
  const { token, offset, limit, search_term } = data;
  const finalParams = {
    limit,
    offset,
    // search_term
    ...(search_term && search_term.length > 0 && { search_term: search_term }),
  };

  return await getData(`master-module/country/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllCityApi(
  data: GetCityListDataPayloadType
): Promise<AxiosResponse> {
  const { token, offset, limit, search_term, state_id, country_id } = data;
  const finalParams = {
    limit,
    offset,
    state_id,
    country_id,
    ...(search_term && search_term.length > 0 && { search_term: search_term }),
  };

  return await getData(`master-module/city/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getAllStateApi(
  data: GetStateListDataPayloadType
): Promise<AxiosResponse> {
  const { token, offset, limit, search_term, country_id } = data;
  const finalParams = {
    limit,
    offset,
    country_id,
    ...(search_term && search_term.length > 0 && { search_term: search_term }),
  };

  return await getData(`master-module/state/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

//get currency Exchange
export async function getCurrnecyExchangeApi(
  data: GetCurrencyExchangeDetailsPayloadType
): Promise<AxiosResponse> {
  const { token, date, baseCurrency, symbol, amount } = data;
  const finalParams = {
    date,
    symbol,
    amount: +amount,
    base_currency: baseCurrency,
  };

  return await getData(`exchange/rate`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// client category
export async function getMasterDataClientCategoryApi(
  data: GetClientCategoryPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, search_term, status } = data;
  const finalParams = {
    limit,
    offset,
    ...(status && { status: status }),
    ...(search_term && search_term.length > 0 && { search_term: search_term }),
  };
  return await getData(`/master-module/client-category/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function createMasterDataClientCategoryApi(
  data: AddClientCategoryPayloadType
): Promise<AxiosResponse> {
  const { token, name_of_category } = data;
  return await postData(
    `/master-module/client-category/add`,
    { name_of_category },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateMasterDataClientCategoryApi(
  data: UpdateClientCategoryPayloadType
): Promise<AxiosResponse> {
  const { token, _id, name_of_category, status } = data;
  return await postData(
    `/master-module/client-category/update`,
    { _id, status, name_of_category },
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

// User's Department
export async function getMasterDataUsersDepartmentApi(
  data: GetUsersDepartmentPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, searchValue, status } = data;
  const finalParams = {
    limit,
    offset,
    status,
    ...(searchValue && searchValue.length > 0 && { search_term: searchValue }),
  };
  return await getData(`finac-crm/department-master/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function createMasterDataUsersDepartmentApi(
  data: AddUsersDepartmentPayloadType
): Promise<AxiosResponse> {
  const { token, departmentName, status } = data;
  const finalData = {
    status,
    department_name: departmentName,
  };

  return await postData(`finac-crm/department-master/add`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateMasterDataUsersDepartmentApi(
  data: UpdateUsersDepartmentPayloadType
): Promise<AxiosResponse> {
  const { token, departmentName, status, _id } = data;
  const finalData = {
    status,
    department_name: departmentName,
    department_id: _id,
  };
  return await postData(`finac-crm/department-master/update`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function deleteMasterDataUsersDepartmentApi(
  data: DeleteUsersDepartmentPayloadType
): Promise<AxiosResponse> {
  const { token, departmentId } = data;
  const finalData = { department_id: departmentId };

  return deleteData(`finac-crm/department-master/delete`, {
    params: {
      ...finalData,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

//Tds Module
export async function getMasterTdsModuleApi(
  data: GetTdsMasterPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, searchValue, sortBy, sortByValue } = data;
  const finalParams = {
    limit,
    offset,
    ...(searchValue && searchValue.length > 0 && { search_term: searchValue }),
    ...(sortBy && sortBy.length > 0 && { sort_by: sortBy }),
    ...(sortByValue &&
      sortByValue.length > 0 && { sort_by_value: sortByValue }),
  };
  return await getData(`/invoice-generation/tax-deducted-at-source/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getMasterTdsModuleSingleApi(
  data: TdsSinglePayloadType
): Promise<AxiosResponse> {
  const { token, tdsId } = data;
  const finalParams = {
    tds_id: tdsId,
  };
  return await getData(`invoice-generation/tax-deducted-at-source/details`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function createMasterTdsModuleApi(
  data: TdsInfoType
): Promise<AxiosResponse> {
  const {
    sectionName,
    natureOfPayment,
    threshold,
    deducte,
    deducteType,
    residentialStatus,
    tdsRates,
    token,
    code,
  } = data;
  const finalData = {
    section_name: sectionName,
    nature_of_payment: natureOfPayment,
    threshold,
    deducte,
    code,
    deducte_type: deducteType,
    residential_status: residentialStatus,
    tds_rates: tdsRates,
  };

  return await postData(
    `invoice-generation/tax-deducted-at-source/add`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateMasterTdsModuleApi(
  data: TdsInfoType
): Promise<AxiosResponse> {
  const {
    sectionName,
    natureOfPayment,
    threshold,
    deducte,
    deducteType,
    residentialStatus,
    tdsRates,
    token,
    tdsId,
    code,
  } = data;
  const finalData = {
    section_name: sectionName,
    nature_of_payment: natureOfPayment,
    threshold,
    deducte,
    tds_id: tdsId,
    deducte_type: deducteType,
    residential_status: residentialStatus,
    tds_rates: tdsRates,
    code,
  };
  return await postData(
    `invoice-generation/tax-deducted-at-source/update`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function deleteMasterTdsModuleApi(
  data: DeleteTdsPayloadType
): Promise<AxiosResponse> {
  const { token, tdsId } = data;
  const finalData = { tds_id: tdsId };

  return deleteData(`invoice-generation/tax-deducted-at-source/delete`, {
    params: {
      ...finalData,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
// skills module
export async function getMasterDataSkillsModuleApi(
  data: GetUsersDepartmentPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, searchValue, status } = data;
  const finalParams = {
    limit,
    offset,
    skill_status: status,
    ...(searchValue && searchValue.length > 0 && { search_term: searchValue }),
  };
  return await getData(`/master-module/skill/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function createMasterDataSkillsModuleApi(
  data: AddSkillsPayloadType
): Promise<AxiosResponse> {
  const { token, skillName, status } = data;
  const finalData = {
    skill_status: status,
    skill_name: skillName,
  };

  return await postData(`master-module/skill/add`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateMasterDataSkillsModuleApi(
  data: UpdateSkillsPayloadType
): Promise<AxiosResponse> {
  const { token, skillName, status, _id } = data;
  const finalData = {
    skill_status: status,
    skill_name: skillName,
    _id,
  };
  return await postData(`master-module/skill/update`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
export async function deleteMasterDataSkillsApi(
  data: DeleteSkillsPayloadType
): Promise<AxiosResponse> {
  const { token, skillId } = data;
  const finalData = { skill_id: skillId };

  return deleteData(`master-module/skill/delete`, {
    params: {
      ...finalData,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
// Education module
export async function getMasterDataQualificationModuleApi(
  data: GetMasterDataListPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, searchValue, status } = data;
  const finalParams = {
    limit,
    offset,
    skill_status: status,
    ...(searchValue && searchValue.length > 0 && { search_term: searchValue }),
  };
  return await getData(`master-module/qualification/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function createMasterDataQualificationModuleApi(
  data: AddQualificationPayloadType
): Promise<AxiosResponse> {
  const { token, qualificationName, status } = data;
  const finalData = {
    qualification_status: status,
    qualification_name: qualificationName,
  };

  return await postData(`master-module/qualification/add`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateMasterDataQualificationModuleApi(
  data: UpdateQualificationPayloadType
): Promise<AxiosResponse> {
  const { token, qualificationName, status, _id } = data;
  const finalData = {
    qualification_status: status,
    qualification_name: qualificationName,
    _id,
  };
  return await postData(`master-module/qualification/update`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
export async function deleteMasterDataQualificationApi(
  data: DeleteQualificationPayloadType
): Promise<AxiosResponse> {
  const { token, qualificationId } = data;
  const finalData = { qualification_id: qualificationId };

  return deleteData(`master-module/qualification/delete`, {
    params: {
      ...finalData,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
// scope of work
export async function getMasterDataScopeOfWorkApi(
  data: GetUsersDepartmentPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, searchValue, status } = data;
  const finalParams = {
    limit,
    offset,
    scope_of_work_status: status,
    ...(searchValue && searchValue.length > 0 && { search_term: searchValue }),
  };
  return await getData(`master-module/scope-of-work/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
export async function createMasterDataScopeOfWorkApi(
  data: AddScopeOfWorkPayloadType
): Promise<AxiosResponse> {
  const { token, scopeOfWorkName, status } = data;
  const finalData = {
    scope_of_work_status: status,
    scope_of_work_name: scopeOfWorkName,
  };

  return await postData(`master-module/scope-of-work/add`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateMasterDataScopeOfWorkApi(
  data: UpdateScopeOfWorkPayloadType
): Promise<AxiosResponse> {
  const { token, scopeOfWorkName, status, _id } = data;
  const finalData = {
    scope_of_work_status: status,
    scope_of_work_name: scopeOfWorkName,
    _id,
  };
  return await postData(`master-module/scope-of-work/update`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function deleteMasterDataScopeOfWorkApi(
  data: DeleteScopeOfWorkPayloadType
): Promise<AxiosResponse> {
  const { token, scopeOfWorkID } = data;
  const finalData = { scope_of_work_id: scopeOfWorkID };

  return deleteData(`master-module/scope-of-work/delete`, {
    params: {
      ...finalData,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

//  TCS module
export async function getMasterTcsModuleApi(
  data: GetTdsMasterPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, searchValue, sortBy, sortByValue } = data;
  const finalParams = {
    limit,
    offset,
    ...(searchValue && searchValue.length > 0 && { search_term: searchValue }),
    ...(sortBy && sortBy.length > 0 && { sort_by: sortBy }),
    ...(sortByValue &&
      sortByValue.length > 0 && { sort_by_value: sortByValue }),
  };
  return await getData(`/invoice-generation/tax-collected-at-source/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getMasterTcsModuleSingleApi(
  data: TcsSinglePayloadType
): Promise<AxiosResponse> {
  const { token, tcsId } = data;
  const finalParams = {
    tcs_id: tcsId,
  };
  return await getData(`invoice-generation/tax-collected-at-source/details`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function createMasterTcsModuleApi(
  data: TcsInfoType
): Promise<AxiosResponse> {
  const {
    sectionName,
    natureOfPayment,
    code,
    threshold,
    deducte,
    tcsRates,
    token,
  } = data;
  const finalData = {
    section_name: sectionName,
    nature_of_payment: natureOfPayment,
    code: code,
    threshold,
    deducte,
    tcs_rates: tcsRates,
  };

  return await postData(
    `invoice-generation/tax-collected-at-source/add`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateMasterTcsModuleApi(
  data: TcsInfoType
): Promise<AxiosResponse> {
  const {
    sectionName,
    natureOfPayment,
    threshold,
    code,
    deducte,
    tcsRates,
    token,
    tcsId,
  } = data;
  const finalData = {
    section_name: sectionName,
    nature_of_payment: natureOfPayment,
    threshold,
    deducte,
    tcs_id: tcsId,
    code: code,
    tcs_rates: tcsRates,
  };
  return await postData(
    `invoice-generation/tax-collected-at-source/update`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function deleteMasterTcsModuleApi(
  data: DeleteTcsPayloadType
): Promise<AxiosResponse> {
  const { token, tcsId } = data;
  const finalData = { tcs_id: tcsId };

  return deleteData(`invoice-generation/tax-collected-at-source/delete`, {
    params: {
      ...finalData,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
export async function checkUniqueCodeApi(
  data: UniqueCheckCodePayloadType
): Promise<AxiosResponse> {
  const { operation, code, id, type, token } = data;
  const finalData = {
    operation,
    code,
    id,
    type,
  };

  return getData(`invoice-generation/tds-tcs/unique/check`, {
    params: {
      ...finalData,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getMasterPdfTemplateApi(
  data: GetMasterDataListPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, searchValue, invoiceType, clientCode } = data;
  const finalParams = {
    limit,
    offset,
    invoice_type: invoiceType,
    ...(searchValue && searchValue.length > 0 && { search_term: searchValue }),
    ...(clientCode && { client_code: clientCode }),
  };
  return await getData(`invoice-generation/pdf-template/client-mapping/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function createMasterPdfTemplateApi(
  data: AddPdfTemplatePayloadType
): Promise<AxiosResponse> {
  const { pdfTemplateName, token, invoiceType } = data;
  const finalData = {
    pdf_template_name: pdfTemplateName,
    invoice_type: invoiceType,
  };

  return await postData(`invoice-generation/pdf-template/add`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateMasterPdfTemplateApi(
  data: UpdatePdfTemplatePayloadType
): Promise<AxiosResponse> {
  const { pdfTemplateName, token, pdfTemplateId, invoiceType } = data;
  const finalData = {
    pdf_template_name: pdfTemplateName,
    pdf_template_id: pdfTemplateId,
    invoice_type: invoiceType,
  };
  return await postData(`invoice-generation/pdf-template/update`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function deleteMasterPdfTemplateApi(
  data: DeletePdfTemplatePayloadType
): Promise<AxiosResponse> {
  const { token, pdfTemplateId } = data;
  const finalData = { pdf_template_id: pdfTemplateId };

  return deleteData(`invoice-generation/pdf-template/delete`, {
    params: {
      ...finalData,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

// Job Title

export async function getMasterDataJobTitleApi(
  data: GetJobTitlePayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, searchValue, status, departmentId, type } =
    data;
  const finalParams = {
    limit,
    offset,
    ...(status === 1 || status === 0 ? { status } : {}),
    ...(searchValue && searchValue.length > 0 && { search_term: searchValue }),
    ...(departmentId && { department_id: departmentId }),
    ...(type && { type: type }),
  };
  return await getData(`master-module/designation/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function createMasterDataJobTitleApi(
  data: AddJobTitlePayloadType
): Promise<AxiosResponse> {
  const { token, departmentId, status, type, jobTitle } = data;
  const finalData = {
    status,
    department_id: departmentId,
    type,
    designation: jobTitle,
  };

  return await postData(`master-module/designation/add`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateMasterDataJobTitleApi(
  data: UpdateJobTitlePayloadType
): Promise<AxiosResponse> {
  const { token, departmentId, jobTitle, status, type, jobTitleId } = data;
  const finalData = {
    status,
    department_id: departmentId,
    designation: jobTitle,
    type,
    _id: jobTitleId,
  };
  return await postData(`master-module/designation/update`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function deleteMasterDataJobTitleApi(
  data: DeleteJobTitlePayloadType
): Promise<AxiosResponse> {
  const { token, jobTitleId, isDeleted } = data;
  const finalData = {
    _id: jobTitleId,
    is_deleted: isDeleted,
  };

  return postData(`master-module/designation/delete`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function addTicketSubCategoryApi(
  data: AddTicketSubCategoryPayloadType
): Promise<AxiosResponse> {
  const { subCategory, description, userType, isActive, token } = data;
  const finalData = {
    sub_category: subCategory,
    description,
    user_type: userType,
    is_active: isActive,
  };

  return await postData(
    `/finac-crm/support/ticket/sub-category/add`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateTicketSubCategoryApi(
  data: UpdateTicketSubCategoryPayloadType
): Promise<AxiosResponse> {
  const { subCategoryId, subCategory, userType, description, isActive, token } =
    data;
  const finalData = {
    sub_category_id: subCategoryId,
    sub_category: subCategory,
    user_type: userType,
    description,
    is_active: isActive,
  };

  return await postData(
    `/finac-crm/support/ticket/sub-category/update`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateTicketSubCategoryStatusApi(
  data: UpdateTicketSubCategoryStatusPayloadType
): Promise<AxiosResponse> {
  const { subCategoryId, isActive, token } = data;
  const finalData = {
    sub_category_id: subCategoryId,
    is_active: isActive,
  };

  return await postData(
    `/finac-crm/support/ticket/sub-category/update/status`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getTicketSubCategoryListApi(
  data: GetTicketSubCategoryListPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, searchTerm, category_id, isActive, userType } =
    data;
  const finalParams = {
    ...(limit && { limit }),
    ...(offset && { offset }),
    ...(searchTerm && { search_term: searchTerm }),
    ...(category_id && { category_id }),
    ...(isActive && { is_active: isActive }),
    ...(userType && { user_type: userType }),
  };

  return await getData(`/finac-crm/support/ticket/sub-category/list`, {
    params: { ...finalParams },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function addTicketCategoryApi(
  data: AddTicketCategoryPayloadType
): Promise<AxiosResponse> {
  const { category, subCategories, usersAssigned, userType, isActive, token } =
    data;
  const finalData = {
    category,
    sub_categorys: subCategories,
    users_assigned: usersAssigned,
    user_type: userType,
    is_active: isActive,
  };

  return await postData(`/finac-crm/support/ticket/category/add`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function updateTicketCategoryApi(
  data: UpdateTicketCategoryPayloadType
): Promise<AxiosResponse> {
  const {
    categoryId,
    category,
    subCategories,
    usersAssigned,
    userType,
    isActive,
    token,
  } = data;
  const finalData = {
    category_id: categoryId,
    category,
    sub_categorys: subCategories,
    users_assigned: usersAssigned,
    user_type: userType,
    is_active: isActive,
  };

  return await postData(
    `/finac-crm/support/ticket/category/update`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateTicketCategoryStatusApi(
  data: UpdateTicketCategoryStatusPayloadType
): Promise<AxiosResponse> {
  const { categoryId, isActive, token } = data;
  const finalData = {
    category_id: categoryId,
    is_active: isActive,
  };

  return await postData(
    `/finac-crm/support/ticket/category/update/status`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getTicketCategoryListApi(
  data: GetTicketCategoryListPayloadType
): Promise<AxiosResponse> {
  const { token, limit, offset, searchTerm, isActive } = data;
  const finalParams = {
    ...(limit && { limit }),
    ...(offset && { offset }),
    ...(searchTerm && { search_term: searchTerm }),
    ...(isActive && { is_active: isActive }),
  };

  return await getData(`/finac-crm/support/ticket/category/list`, {
    params: { ...finalParams },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getTicketCategoryDetailsApi(
  data: GetTicketCategoryDetailsPayloadType
): Promise<AxiosResponse> {
  const { token, categoryId } = data;

  return await getData(`/finac-crm/support/ticket/category/details`, {
    params: { category_id: categoryId },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// KPI Module

export async function addKpiApi(
  data: AddKpiPayloadType
): Promise<AxiosResponse> {
  const { params, token } = data;

  return await postData(`finac-crm/performance-management/kpi/add`, params, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getKpiListApi(
  data: GetKpiListPayloadType
): Promise<AxiosResponse> {
  const { params, token } = data;

  return await getData(`finac-crm/performance-management/kpi/list`, {
    params: params,

    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getSingleKpiDetailsApi(
  data: GetSingleKpiDetailsPayloadType
): Promise<AxiosResponse> {
  const { kpiId, token } = data;
  const finalParams = {
    kpi_id: kpiId,
  };

  return await getData(`finac-crm/performance-management/kpi/details`, {
    params: { ...finalParams },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function updateKpiDetailsApi(
  data: UpdateKpiPayloadType
): Promise<AxiosResponse> {
  const { params, token } = data;

  return await postData(`finac-crm/performance-management/kpi/update`, params, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

// kra module
export async function addKraApi(
  data: AddKraPayloadType
): Promise<AxiosResponse> {
  const { params, token } = data;
  return await postData(`/finac-crm/performance-management/kra/add`, params, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function listKraApi(
  data: ListKraPayloadType
): Promise<AxiosResponse> {
  const { offset, limit, searchTerm, isActive, token } = data;
  const finalParams = {
    ...(limit && { limit }),
    ...(offset && { offset }),
    ...(searchTerm && { search_term: searchTerm }),
    ...(isActive !== undefined && { is_active: isActive }),
  };

  return await getData(`/finac-crm/performance-management/kra/list`, {
    params: { ...finalParams },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function updatekraApi(
  data: UpdateKraPayloadType
): Promise<AxiosResponse> {
  const { params, token } = data;

  return await postData(
    `/finac-crm/performance-management/kra/update`,
    params,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateKraStatusApi(
  data: UpdateKraStatusPayloadType
): Promise<AxiosResponse> {
  const { params, token } = data;

  return await postData(
    `/finac-crm/performance-management/update/status`,
    params,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function deleteKraApi(
  data: DeleteKraPayloadType
): Promise<AxiosResponse> {
  const { type, id, token } = data;
  const finalData = {
    type,
    id,
  };

  return postData(`/finac-crm/performance-management/delete`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

// nature of transaction

export async function getNatureOfTransactionListApi(
  data: NatureOfTransactionPayloadType
): Promise<AxiosResponse> {
  const { token, type } = data;
  const finalData = {
    type,
  };

  return await getData(`invoice-generation/nature-of-transaction/list`, {
    params: { ...finalData },

    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// relationship type

export async function getRelationshipTypeListApi(
  data: any
): Promise<AxiosResponse> {
  return await getData(`invoice-generation/relationship-type/list`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": data,
    },
  });
}

// applicable act type

export async function getApplicableActListApi(
  data: any
): Promise<AxiosResponse> {
  return await getData(`invoice-generation/applicable-act/list`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": data,
    },
  });
}
